module.exports = __webpack_public_path__ + "img/연남동 맛집.fa211adf.png";